// extracted by mini-css-extract-plugin
module.exports = {"brand":"StickyHeader_brand__3tr21","show":"StickyHeader_show__2kXaC"};